/**
 * Export component file to be used on project
 */

import Survey from './Survey';
export default Survey;